// extracted by mini-css-extract-plugin
export default {"contactEnvelope":"EnvelopeContact_contactEnvelope__eaTj-","contactEnvelopeText":"EnvelopeContact_contactEnvelopeText__DoRUP"};